const EVENT_LIST = Symbol('event-list');
/**
 * Decorates a given class property, updating the parent class with a list of all AwesomeEvents.
 *
 * @param instance - Decorated property;
 * @param name - Name of the decorated property.
 */
function AwesomeEvent(instance, name) {
    const clazz = instance.constructor;
    const eventList = clazz[EVENT_LIST] || [];
    clazz[EVENT_LIST] = [...eventList, name];
}
/**
 * Returns a list of all AwesomeEvents associated with a given class.
 *
 * @param clazz - The class being searched.
 */
function getEventList(clazz) {
    return clazz.constructor[EVENT_LIST] ?? [];
}
export { AwesomeEvent, getEventList, };
export default AwesomeEvent;
//# sourceMappingURL=awesome-event.js.map